// extracted by css-extract-rspack-plugin
export default {"root":"AUaPP","selected":"bl8ZJ"};